<template>
  <b-navbar type="dark" variant="success">
    <b-navbar-brand toggleable="lg">
      <span class="d-sm-inline d-md-none">FICAR</span>
      <span class="d-none d-md-inline"
        >FICAR - Ferramenta de Identificação e Controle de Acesso ao
        Refeitório</span
      >
    </b-navbar-brand>
    <b-navbar-nav class="ml-auto">
      <b-nav-item-dropdown right v-show="$store.getters.getLoggedUser">
        <!-- Using 'button-content' slot -->
        <template v-slot:button-content>
          <em>{{
            $store.getters.getLoggedUser
              ? $store.getters.getLoggedUser.username
              : ""
          }}</em>
        </template>
        <b-dropdown-item to="/sobre">Sobre</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="logout">Sair</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
export default {
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
    };
  },
  methods: {
    logout() {
      localStorage.removeItem(
        "__" + process.env.VUE_APP_CI_PROJECT_NAME + "_app"
      );
      this.$http.defaults.headers.common["Authorization"] = null;
      this.$store.commit("setLoggedUser", null);
      this.$store.commit("setPermission", null);
      this.$session.destroy();
      this.$router.push("/login");
    },
  },
};
</script>

<style>
.version {
  font-size: 0.6em;
}
</style>
